import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { bsc, bscTestnet } from '@reown/appkit/networks'
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient()

export const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || ''

export const networks = [bsc, bscTestnet] as any

export let wagmiAdapter: WagmiAdapter | null = null

if (projectId) {
  wagmiAdapter = new WagmiAdapter({
    networks,
    projectId,
    ssr: true
  })

  createAppKit({
    adapters: [wagmiAdapter],
    networks,
    projectId,
    metadata: {
      name: 'Zhongkui Game',
      description: 'Mobile Game with Web3 wallet',
      url: typeof window !== 'undefined' ? window.location.origin : 'https://zhongkui.game',
      icons: [typeof window !== 'undefined' ? `${window.location.origin}/favicon.ico` : 'https://zhongkui.game/favicon.ico']
    },
    features: {
      analytics: true
    }
  })
}
